export default {
  get_review_program_statistic: '/program/api/get-overview-statistic',
  update_path: '/path/update',
  update_review_evidence: '/path/update-review-evidence',
};
